/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.concat.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
// 引入vux组件
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import Search from "vux/src/components/search/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import XInput from "vux/src/components/x-input/index.vue"; // this line is trasformed by vux-loader // 引入api接口
import {
// getServerItemList,        // 服务项目
// getOrderTaglist,          // 工单标签
apiprojectList,
// 全部工单
apiprojectCount // 全部工单数量
} from '@/api';

// 引入常量
import { orderStatusList, relevanceList, orderSortList, receiptStateList, settlementStateList, evaluateStateList, orderSourceList, timeoutStateList, abnormalStateList, priorityList, getEventFilterState } from '@/constant';
import ScrollerList from '@/components/ScrollerList';
import OrderItem from '@/components/ScrollerList/OrderItem';
export default {
  name: 'Order',
  props: {
    shopOrderId: {
      type: [String, Number],
      default: ''
    }
  },
  components: {
    Group: Group,
    ViewBox: ViewBox,
    Search: Search,
    PopupPicker: PopupPicker,
    XInput: XInput,
    Cell: Cell,
    ScrollerList: ScrollerList,
    OrderItem: OrderItem,
    SearchDetail: function SearchDetail() {
      return import('@/components/SearchDetail');
    },
    SmyDatetimeRange: function SmyDatetimeRange() {
      return import('@/components/SmyDatetimeRange');
    },
    SmyTab: function SmyTab() {
      return import('@/components/SmyTab');
    }
  },
  data: function data() {
    return {
      // 常量
      getEventFilterState: getEventFilterState,
      orderStatusList: orderStatusList,
      relevanceList: relevanceList,
      orderSortList: orderSortList,
      receiptStateList: receiptStateList,
      settlementStateList: settlementStateList,
      evaluateStateList: evaluateStateList,
      orderSourceList: orderSourceList,
      timeoutStateList: timeoutStateList,
      abnormalStateList: abnormalStateList,
      priorityList: priorityList,
      // 筛选列表
      orderTypeList: [],
      // 模板类型
      serverItem: [],
      // 服务项目
      workerlist: [],
      // 服务人员
      orderTagList: [],
      // 工单标签
      orderList: [],
      badgeCountList: {},
      // 时间类型
      timeTypeList: [{
        value: '1',
        name: i18n.tc("259")
      }, {
        value: '2',
        name: i18n.tc("507")
      }, {
        value: '3',
        name: i18n.tc("154")
      }],
      pageIndex: 0,
      pageSize: 10,
      isShowPicker: false,
      showSearchDetail: false,
      isShowTemplate: false,
      // 模板列表
      checkCustomerShow: false,
      // 选择客户
      checkLinkPersonShow: false,
      // 选择联系人
      showSelectSeivice: false,
      // 服务人员
      isSearch: false,
      // 筛选字段
      initSearchForm: {
        keyword: '',
        // 快捷查询条件
        type: '1',
        sortType: ['1'],
        timeType: '1',
        customView: -1,
        // 自定义视图
        customName: '',
        states: [],
        customLinkPerson: '',
        customPhone: '',
        gpsAddr: '',
        takeStart: '',
        takeEnd: '',
        visitStart: '',
        visitEnd: '',
        finishStart: '',
        finishEnd: '',
        orderType: [],
        state: 0,
        serviceId: [],
        servicePersonalId: '',
        servicePersonalName: '',
        creatorName: '',
        priority: [],
        orderDue: '',
        isServiceSettlement: [],
        isCreateReceipt: [],
        evaluateState: [],
        order_label: [],
        abnormal_state: [],
        order_channel: [],
        take_order_user_id: ''
      },
      searchForm: {}
    };
  },
  filters: {
    // 搜索框左侧顶部类型过滤
    relevanceListFilter: function relevanceListFilter(value, list) {
      var realName = '';
      var res = list.filter(function (item) {
        return item.value === Number(value);
      });
      if (res.length === 1) {
        realName = res[0].name;
      }
      return realName;
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user', 'pageReload'])), {}, {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 50 - 4 * fontSize - 40;
    },
    relevanceListFilter: function relevanceListFilter() {
      var relevanceList = this.relevanceList;
      if (this.user.sysrole !== 2) {
        relevanceList = relevanceList.filter(function (item) {
          return item.value !== 2;
        });
      }
      return relevanceList;
    },
    // 需控制返回按钮的字段集合
    isShowKeyMerge: function isShowKeyMerge() {
      return {
        checkCustomerShow: this.checkCustomerShow,
        checkLinkPersonShow: this.checkLinkPersonShow,
        showSelectSeivice: this.showSelectSeivice
      };
    },
    // 格式化搜索条件
    searchFormFormat: function searchFormFormat() {
      return {
        keyword: this.searchForm.keyword,
        // 快捷查询条件
        state: this.searchForm.state // 自定义视图
      };
    }
  }),
  watch: {
    'searchForm.timeType': {
      handler: function handler(val) {
        this.searchForm.takeStart = '';
        this.searchForm.takeEnd = '';
        this.searchForm.visitStart = '';
        this.searchForm.visitEnd = '';
        this.searchForm.finishStart = '';
        this.searchForm.finishEnd = '';
      }
    },
    isShowTemplate: function isShowTemplate(val) {
      if (val) {
        this._showHomebottomBar(false);
      } else {
        this._showHomebottomBar(true);
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_showHomebottomBar', '_pageReload'])), {}, {
    goDetail: function goDetail(item) {
      if (item.fk_t_ep_event_tmpl_id) {
        this.$router.push({
          name: 'EventDetail',
          params: {
            eventId: String(item.id)
          }
        });
      } else {
        this.$router.push({
          name: 'ProjectDetail',
          params: {
            oid: item.oid
          }
        });
      }
    },
    loadList: function loadList() {
      var _this = this;
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var operation = arguments.length > 1 ? arguments[1] : undefined;
      if (reset) {
        this.pageIndex = 0;
        this.$vux.loading.show({
          text: i18n.tc("206")
        });
      }
      return new Promise(function (resolve, reject) {
        var data = _objectSpread(_objectSpread({
          pageIndex: _this.pageIndex,
          pageSize: _this.pageSize
        }, _this.searchFormFormat), {}, {
          fk_t_shop_order_id: _this.shopOrderId
        });
        Promise.all([apiprojectList(data), apiprojectCount(data)]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            res = _ref2[0],
            count = _ref2[1];
          if (!res.success) return;
          // 不重置数据累计
          if (!reset) {
            _this.orderList = Object.freeze([].concat(_toConsumableArray(_this.orderList), _toConsumableArray(res.data)));
          } else {
            _this.orderList = Object.freeze(res.data);
            setTimeout(function () {
              _this.$vux.loading.hide();
            }, 300);
            // 搜索时滚动至顶部
            if (operation === 'search') {
              _this.$refs.orderList.scrollToTop();
            }
          }
          resolve();
          // 判断是否有新数据
          if (_this.orderList.length < count.data.all_count) {
            setTimeout(function () {
              _this.$refs['orderList'] && _this.$refs['orderList'].enablePullup();
            }, 100);
          } else {
            setTimeout(function () {
              _this.$refs['orderList'] && _this.$refs['orderList'].disablePullup();
            }, 100);
          }
        });
      });
    },
    // 下拉刷新
    onPulldownLoading: function onPulldownLoading() {
      var _this2 = this;
      this.loadList(true).then(function () {
        _this2.$refs['orderList'] && _this2.$refs['orderList'].donePulldown();
        _this2.searchForm.finishStart = '';
        _this2.searchForm.finishEnd = '';
        _this2.getBadgeCount();
      });
    },
    // 上拉加载
    onPullupLoading: function onPullupLoading() {
      var _this3 = this;
      this.pageIndex = this.pageIndex + 1;
      this.loadList().then(function () {
        _this3.$refs['orderList'] && _this3.$refs['orderList'].donePullup();
      });
    },
    // 获取tab徽标数量
    getBadgeCount: function getBadgeCount() {
      var _this4 = this;
      var statusList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.orderStatusList;
      if (statusList.length > 0) {
        var data = _objectSpread(_objectSpread({}, this.searchFormFormat), {}, {
          fk_t_shop_order_id: this.shopOrderId
        });
        apiprojectCount(data).then(function (res) {
          if (res.success) {
            var _data = res.data;
            _this4.badgeCountList = {
              0: _data.all_count,
              1: _data.appoint_count,
              2: _data.server_count,
              3: _data.wait_evaluate_count,
              4: _data.evaluate_count,
              5: _data.cancel_count
            };
          }
        });
      }
    },
    // 重置搜索条件方法
    initSearchFormFunc: function initSearchFormFunc() {
      var exclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var resetPicker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var initSearchForm = JSON.parse(JSON.stringify(this.initSearchForm));
      for (var key in initSearchForm) {
        if (exclude.indexOf(key) === -1) {
          this.$set(this.searchForm, key, initSearchForm[key]);
        }
      }
      if (resetPicker) {
        this.pickerDataReset();
      }
    },
    // 单选数据源重置
    pickerDataReset: function pickerDataReset() {
      var _this5 = this;
      var keys = ['receiptStateList', 'settlementStateList', 'evaluateStateList', 'orderSourceList', 'timeoutStateList', 'abnormalStateList', 'priorityList', 'orderTypeList', 'serverItem', 'workerlist', 'orderTagList'];
      var _loop = function _loop() {
        var key = _keys[_i];
        var data = _this5.$data[key];
        _this5.$data[key] = [];
        setTimeout(function () {
          _this5.$data[key] = data;
        }, 100);
      };
      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        _loop();
      }
    },
    tabChange: function tabChange(val) {
      this.loadList(true, 'search');
    },
    // 重置搜索条件
    resetSearchForm: function resetSearchForm(val) {
      this.isSearch = false;
      this.initSearchFormFunc(['type']);
      this.loadList(true, val);
      this.getBadgeCount();
    }
  }),
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this._showHomebottomBar(true);
    this.isShowTemplate = false;
    this.showSearchDetail = false;
    next();
  },
  // 页面缓存
  activated: function activated() {
    if (this.pageReload.order) {
      // 切换角色时筛选列表重置
      if (this.pageReload.orderSearch) {
        this.searchForm.type = '1';
        this.resetSearchForm();
        this._pageReload({
          orderSearch: false
        });
      } else {
        this.loadList(true);
      }
      this._pageReload({
        order: false
      });
    }
    this.getBadgeCount();
  },
  created: function created() {
    this.initSearchFormFunc([], false);
    this._pageReload({
      order: true
    });
  }
};